import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { ProductSubtype } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface ProductSubtypeWatchProps {
    productSubtype?: ProductSubtype;
    productTypeId?: number;
}

export function ProductSubtypeInput({ disabled = false }: Props) {
    const { productSubtype, productTypeId } =
        useFormContext<ProductSubtypeWatchProps>().getValues();

    const productSubtypeQueryResult = useQuery({
        queryKey: ['productSubtypes', productTypeId],
        queryFn: () =>
            Api.Products.Subtypes.getProductSubtypes({
                page: 0,
                size: 1000,
                sort: 'name,asc',
                productTypeId,
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: productSubtype ? [productSubtype] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Alcohol Subtype"
            name="productSubtypeId"
            loading={productSubtypeQueryResult.isLoading}
            multiple={false}
            options={productSubtypeQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: ProductSubtype,
                    value?: ProductSubtype | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
                getOptionKey(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.id}-${option.productTypeId}`;
                },
            }}
        />
    );
}
